module.exports = __webpack_public_path__ + "img/us.ef7f0a8f.svg";